import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './Components/Home';
import Services from './Components/Services';
import Rooms from './Components/Rooms';
import News from './Components/News';
import About from './Pages/About';
import Contact from './Pages/Contact';
import FAQ from './Pages/FAQ';
import Gallery from './Pages/Gallery';
import Price from './Pages/Price';
import Teams from './Pages/Teams';


  

const router = createBrowserRouter([
   {
    path: '/',
    element: <App />, // Main Layout (Navbar + Footer)
    children: [
      { path: '/', element: <Home /> },
      { path: '/home', element: <Home /> },
      { path: '/page', element: <About/> },
      { path: '/service', element: <Services /> },
      { path: '/rooms', element: <Rooms /> },
      { path: '/news', element: <News /> },

      // Page Routes
      { path: '/page/about', element: <About /> },
      { path: '/page/contact', element: <Contact /> },
      { path: '/page/faq', element: <FAQ /> },
      { path: '/page/gallery', element: <Gallery /> },
      { path: '/page/price', element: <Price /> },
      { path: '/page/teams', element: <Teams /> },
    ],
  },

])


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<RouterProvider router={router}>
 
</RouterProvider>

);

reportWebVitals();

